import jwtDecode from "jwt-decode";
import {router} from "@/router";
import {http} from "@/misc/http";
import Keycloak from "keycloak-js";
import {config} from "@/state/config";

let auth;

const basicAuth = {
  token: null,
  logout_timer: null,
  user: null,

  _clear() {
    localStorage.removeItem("token");
    this.token = null;
    this.user = null;
  },

  _clearAutologout() {
    if (this.logout_timer) clearTimeout(this.logout_timer);
    this.logout_timer = null;
  },

  login(token) {
    this._clearAutologout();
    try {
      const claim = jwtDecode(token);
      const exp_in = claim.exp * 1000 - Date.now();
      if (exp_in < 10000) throw Error();
      this.token = token;
      localStorage.setItem("token", token);
      this.user = Object.assign({}, claim);
      delete this.user['exp'];
      this.logout_timer = setTimeout(() => {
        this.logout();
        router.push({
          name: "signin",
        });
      }, claim.exp * 1000 - Date.now());
    } catch (e) {
      this._clear();
    }
  },

  async oneTimeLogin(otltoken) {
    this.login(await http.post("/auth/otl/" + otltoken));
  },

  _tryLogin() {
    this.login(localStorage.getItem("token"));
  },

  isLoggedIn() {
    return !!this.token;
  },

  getToken() {
    return this.token;
  },

  logout() {
    this._clearAutologout();
    this._clear();
    router.replace({
      name: "signin",
    });
  },

}

const keycloakAuth = {
  _keycloak: null,
  user: null,

  async init(keycloakConfig) {
    this._keycloak = new Keycloak({
      url: keycloakConfig.url,
      realm: keycloakConfig.realm,
      clientId: keycloakConfig.clientId,
    });
    const authenticated = await this._keycloak.init({
      onLoad: 'login-required',
      redirectUri: window.location.href,
    });
    if (!authenticated) {
      this._keycloak.logout();
      throw Error("Not authenticated");
    }
    const tokenParsed = this._keycloak.tokenParsed;

    const roles = tokenParsed.resource_access?.[keycloakConfig.clientId]?.roles || [];

    if (
      !roles.includes(keycloakConfig.userRole)
      && !roles.includes(keycloakConfig.adminRole)
    ) {
      this._keycloak.logout();
      throw Error("Not authenticated");
    }

    this.user = {
      login: tokenParsed.sub,
      name: tokenParsed.family_name + " " + tokenParsed.given_name,
      admin: roles.includes(keycloakConfig.adminRole),
    }

  },

  async getToken() {
    await this._keycloak.updateToken();
    return this._keycloak.token;
  },

  logout() {
    this._keycloak.logout();
  },

}

async function initAuth() {
  if (config.keycloak === null) {
    auth = basicAuth;
    auth._tryLogin();
  } else {
    auth = keycloakAuth;
    await auth.init(config.keycloak);
  }
}

export {
  auth,
  initAuth,
}